<template>
    <div class="query_list">
        <div class="query_input_box">
            <el-input placeholder="请输入单位名称或域名或关键词或备案号" v-model="queryObj.keyword" @keyup.enter="changekeyWord" class="input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="changekeyWord">搜索</el-button>
            </el-input>
        </div>
        <div class="query_box">
            <div class="query_box_item">
                <div class="title">搜索平台：</div>
                <el-radio-group v-model="queryObj.stage" @change="changeStage">
                    <el-radio-button v-for="(item,index) in checkboxList1" :key="index" :label="item.val">
                        {{item.text}}
                    </el-radio-button>
                </el-radio-group>
            </div>
            <div class="query_box_item jg">
                <div class="title">更多筛选：</div>
                <el-cascader
                    placeholder="企业地区"
                    clearable
                    v-model="queryObj.down"
                    :options="provinceData"
                    :props="{ value: 'label'}"
                    @change="handleChangedi">
                </el-cascader>
                <el-cascader
                    placeholder="行业分类"
                    clearable
                    v-model="queryObj.industry"
                    :options="industry"
                    @change="handleChangehang">
                </el-cascader>
            </div>
            <div class="query_box_item wu">
                <div class="title">联系方式：</div>
                <el-select v-model="queryObj.isPhone" placeholder="手机号码" @change="changeisPhone">
                    <el-option
                        v-for="(item,index) in xzArr"
                        :key="index"
                        :label="'手机号码:'+item.text"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="queryObj.isTel" placeholder="固定电话" @change="changeisTel">
                    <el-option
                        v-for="(item,index) in xzArr"
                        :key="index"
                        :label="'固定电话:'+item.text"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="queryObj.isEmail" placeholder="邮箱" @change="changeisEmail">
                    <el-option
                        v-for="(item,index) in xzArr"
                        :key="index"
                        :label="'邮箱:'+item.text"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="queryObj.isUrl" placeholder="网站" @change="changeisUrl">
                    <el-option
                        v-for="(item,index) in xzArr"
                        :key="index"
                        :label="'网站:'+item.text"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
    </div>
</template>
<script>
import {provinceData,industry} from '../common/newData'
export default {
    name:"queryList",
    data(){
        return{
            provinceData:provinceData,
            industry:industry,
            queryObj:{
                keyword:'',
                stage:0,
                isPhone:'',
                isTel:'',
                isEmail:'',
                isUrl:'',
                down:[],
                industry:[]
            },
            checkboxList1: [
				{
					text: '全部',
					val:0
				},
				{
					text: '百度搜索',
					val:1
				},
				{
					text: '360搜索',
					val:2
				},
				{
					text: '搜狗搜索',
					val:3
				},
				{
					text: '神马搜索',
					val:4
				}
			],
            xzArr:[
				{
					text:'有',
					value:"0"
				},
				{
					text:'无',
					value:"1"
				},
				{
					text:'全部',
					value:''
				},
			],
        }
    },
    methods:{
        handleChangedi() {
            var queryObj = {
                keyword:this.queryObj.keyword,
                stage:this.queryObj.stage,
                isPhone:this.queryObj.isPhone,
                isTel:this.queryObj.isTel,
                isEmail:this.queryObj.isEmail,
                isUrl:this.queryObj.isUrl,
                down:this.queryObj.down,
                industry:this.queryObj.industry.toString()
            }
            this.$emit('queryType',queryObj);
        },
        handleChangehang(e) {
            var queryObj = {
                keyword:this.queryObj.keyword,
                stage:this.queryObj.stage,
                isPhone:this.queryObj.isPhone,
                isTel:this.queryObj.isTel,
                isEmail:this.queryObj.isEmail,
                isUrl:this.queryObj.isUrl,
                down:this.queryObj.down,
                industry:this.queryObj.industry.toString()
            }
            this.$emit('queryType',queryObj);
        },
        changeisPhone(e){
            var queryObj = {
                keyword:this.queryObj.keyword,
                stage:this.queryObj.stage,
                isPhone:this.queryObj.isPhone,
                isTel:this.queryObj.isTel,
                isEmail:this.queryObj.isEmail,
                isUrl:this.queryObj.isUrl,
                down:this.queryObj.down,
                industry:this.queryObj.industry.toString()
            }
            this.$emit('queryType',queryObj);
        },
        changeisTel(e){
            var queryObj = {
                keyword:this.queryObj.keyword,
                stage:this.queryObj.stage,
                isPhone:this.queryObj.isPhone,
                isTel:this.queryObj.isTel,
                isEmail:this.queryObj.isEmail,
                isUrl:this.queryObj.isUrl,
                down:this.queryObj.down,
                industry:this.queryObj.industry.toString()
            }
            this.$emit('queryType',queryObj);
        },
        changeisEmail(e){
            var queryObj = {
                keyword:this.queryObj.keyword,
                stage:this.queryObj.stage,
                isPhone:this.queryObj.isPhone,
                isTel:this.queryObj.isTel,
                isEmail:this.queryObj.isEmail,
                isUrl:this.queryObj.isUrl,
                down:this.queryObj.down,
                industry:this.queryObj.industry.toString()
            }
            this.$emit('queryType',queryObj);
        },
        changeisUrl(e){
            var queryObj = {
                keyword:this.queryObj.keyword,
                stage:this.queryObj.stage,
                isPhone:this.queryObj.isPhone,
                isTel:this.queryObj.isTel,
                isEmail:this.queryObj.isEmail,
                isUrl:this.queryObj.isUrl,
                down:this.queryObj.down,
                industry:this.queryObj.industry.toString()
            }
            this.$emit('queryType',queryObj);
        },
        changeStage(e){
            var queryObj = {
                keyword:this.queryObj.keyword,
                stage:this.queryObj.stage,
                isPhone:this.queryObj.isPhone,
                isTel:this.queryObj.isTel,
                isEmail:this.queryObj.isEmail,
                isUrl:this.queryObj.isUrl,
                down:this.queryObj.down,
                industry:this.queryObj.industry.toString()
            }
            this.$emit('queryType',queryObj);
        },
        changekeyWord(){
            var queryObj = {
                keyword:this.queryObj.keyword,
                stage:this.queryObj.stage,
                isPhone:this.queryObj.isPhone,
                isTel:this.queryObj.isTel,
                isEmail:this.queryObj.isEmail,
                isUrl:this.queryObj.isUrl,
                down:this.queryObj.down,
                industry:this.queryObj.industry.toString()
            }
            this.$emit('queryType',queryObj);
        }
    },
    mounted(){
        this.queryObj.keyword = this.$route.query.text;
    }
}
</script>
<style lang="scss" scoped>
.el-button{
    background: #1F81F8 !important;
    color: #FFFFFF !important;
    padding-bottom: 8 !important;
    padding-top: 8 !important;
    margin-top: -30px !important;
}
.query_box_item.wu .el-input__inner{
    /* border: none; */
    font-size: 16px;
}
.query_box_item.wu .el-select{
    width: 16%;
    margin-right: 40px;
    color: #666666;
}
.query_box_item .el-cascader{
    width: 16%;
    margin-right: 40px;
}
.query_list{
    height: auto;
    @media screen and (max-width: 1400px){
        width: 960px;
        margin: 0 auto 0;
        background-color: #fff;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
        margin: 0 auto 0;
        background-color: #fff;
    }
    >div.query_input_box{
        width: 100%;
        height: auto;
        padding: 20px 35px;
        box-sizing: border-box;
        border-bottom: 1px solid #F6F7FB;
        .input-with-select{
            width: 50%;
        }
    }
    >div.query_box{
        width: 100%;
        height: auto;
        padding: 20px 36px;
        box-sizing: border-box;
        >div.query_box_item{
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            cursor: default;
            >div.title{
                line-height: 40px;
                font-weight: 500;
                color: #000000;
                font-size: 16px;
                margin-right: 10px;
            }
        }
        >div.query_box_item.jg{
            margin-top: 20px;
            margin-bottom: 20px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/modular/querylist.vue